import React from 'react';
import ZVersions from '../../z-versions';
import ZPublish from '../../z-publish';

const VersionsView = ({
  actions,
  id,
  modalState,
  paths,
  published,
  onCloseModal,
  onClickUnpublish,
  saved,
  showModal,
  usageReferences,
  publishErrors,
}) => (
  <>
  <ZVersions
    actions={actions}
    entityId={id}
    entityType="landingPageCategories"
    onClickUnpublish={onClickUnpublish}
    published={published}
    saved={saved}
  />
  {showModal && (
    <ZPublish
      entityId={id}
      entityType="LandingPageCategory"
      modalState={modalState}
      onCloseModal={onCloseModal}
      paths={paths}
      showModal={showModal}
      usageReferences={usageReferences}
      publishErrors={publishErrors}
      usageReferencesError={(
        <>
          <h2>This page is being used.</h2>
          <p>
            Please go to the Usage References tab.
            <br/>
            Visit the pages listed and remove it from the list of pages or the navigation bar.
          </p>
        </>
      )}
    />
  )}
  </>
);

export default VersionsView;
